import { Signal, useComputed } from "@suse-o11y/signal";

/**
 * This signal holds whether tooltip is enabled in the application.
 * It is initially false to avoid loading the heavy `@radix-ui/react-tooltip` library
 * until the user hovers of focuses a tooltip trigger.
 */
const isEnabled = Signal(import.meta.env.MODE === "test");

export function useIsEnabled(): boolean {
	return useComputed((monitor) => isEnabled.read(monitor), []);
}

export function enable(): void {
	isEnabled.write(true);
}
